import { VAT_NUMBER_LABEL } from '~~/constants/commerceTools';
import { extractCustomField } from '~~/helpers/customFields';
import type { Address } from '~~/types/commercetools';

// Legacy customer addresses may still carry VAT in fax for previously saved addresses
export const legacyVatNumberKeyOfCustomerAddress = 'fax';

const parseVatNumber = (value: string): string => {

  try {

    const parsedValue = JSON.parse(value);

    return typeof parsedValue === 'string' ? parsedValue : value;

  } catch {

    return value;

  }

};

export const getVatNumberFromCustomerAddress = (address: Maybe<Partial<Address>>): string => {

  if (!address) {

    return '';

  }

  const customVatNumber = extractCustomField(address, VAT_NUMBER_LABEL);

  if (customVatNumber !== undefined) {

    return parseVatNumber(customVatNumber);

  }

  return address[legacyVatNumberKeyOfCustomerAddress] ?? '';

};
